import { Category, Reason } from "src/common/types/visit";
import { Branch } from "src/common/types/branch";

export class DeepLink {
  category?: Category;
  reason?: Reason;
  branch?: Branch;
  anyServiceRep: boolean = false;
}

export class DeepLinkStatus {
  isDeepLinkLoading: boolean = false;
  isDeepLinkResolved: boolean = false;
  isServiceRepSkipResolved: boolean = false;
  isDeepLinkOveride: boolean = false;
}
